import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'DayNight',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h(
        "g",
        {
          attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }
        },
        [h("line", {
          attrs: { x1: "16", y1: "12", x2: "16", y2: "3" }
        }), h("polyline", {
          attrs: { points: "11,7 16,12 21,7" }
        }), h("line", {
          attrs: { x1: "31", y1: "29", x2: "1", y2: "29" }
        }), h("path", {
          attrs: { d: "M9 24c0-3.87 3.13-7 7-7s7 3.13 7 7" }
        }), h("line", {
          attrs: { x1: "1", y1: "24", x2: "4", y2: "24" }
        }), h("line", {
          attrs: { x1: "31", y1: "24", x2: "28", y2: "24" }
        }), h("line", {
          attrs: { x1: "26.61", y1: "13.39", x2: "24.49", y2: "15.51" }
        }), h("line", {
          attrs: { x1: "5.39", y1: "13.39", x2: "7.51", y2: "15.51" }
        })]
      )]
    );
  }
};